import { ProfileInfoType } from '@components/match/profile/types';

import classnames from 'classnames/bind';
import styles from './profileTab.module.scss';
const cx = classnames.bind(styles);

interface IProfileTabProps {
  activeTab: ProfileInfoType;
  onClickTab: (type: ProfileInfoType) => void;
}

const ProfileTab = ({ activeTab, onClickTab }: IProfileTabProps) => {
  return (
    <section className={cx('container')}>
      <a role="button" className={cx('tab', { active: activeTab === 'GENERAL' })} onClick={() => onClickTab('GENERAL')}>
        일반 직군
      </a>
      <a
        role="button"
        className={cx('tab', { active: activeTab === 'DEVELOPER' })}
        onClick={() => onClickTab('DEVELOPER')}
      >
        개발 직군
      </a>
    </section>
  );
};

export default ProfileTab;
